module.exports = __webpack_public_path__ + "img/blocks-3.09a2f39d.png";